import { render, staticRenderFns } from "./PreviewDoc.vue?vue&type=template&id=7a84b80e"
import script from "./PreviewDoc.vue?vue&type=script&lang=js"
export * from "./PreviewDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports